import { client } from "helpers/client";
import { Params } from "helpers/custom-data-source";
import { atom } from "recoil";
import qs from "qs";

class NotificationsService {
  getAllNotifications = (params: Params) => {
    return client("/Notifiction/GetPagedList", { params, paramsSerializer: (params) => qs.stringify(params) });
  };
  getNotificationsLength = () => {
    return client("/Notifiction/GetCountOfUnRead");
  };
  markRead = (notificationId: any) => {
    return client("/Notifiction/MarkOneNotificationToBeRead", { params: { notificationId: notificationId } });
  };
  hideNotify = (notificationId: any) => {
    return client("/Notifiction/MarkNotificationToBeHide", { params: { notificationId: notificationId } });
  };
}

const _NotificationsService = new NotificationsService();

export default _NotificationsService;

export const NotiFilterAtom = atom({
  key: "notify",
  default: {
    skipCount: 0,
    maxResultCount: 10,
    filter: '{"isRead":{"operator":"Equals","value":false}}',
    searchTerm: ""
  }
});

// 1 => TicketDetail
// 2 => LicensesRequests
// 3 => UnPaidInvoices
// 4 => PaidInvoices
// 5 => RefundedInvoices
// 6 => AppMange
// 7 => AppDetail

export const GetNotificationsRoutes = (notification: any) => {
  switch (notification?.pageDetailId) {
    case 1:
      return { route: `/tickets` };
    case 2:
      return { route: `/my-apps/${notification?.versionSubscribtionId}/licenses?device` };
    case 3:
      return { route: `/invoices/unpaid` };
    case 4:
      return { route: `/invoices/paid` };
    case 5:
      return { route: `/invoices/refunded` };
    case 6:
      return { route: `/my-apps/${notification?.versionSubscribtionId}/Manage` };
    case 7:
      return { route: `/my-apps/${notification?.versionSubscribtionId}/licenses?device` };
    default:
      break;
  }
};
